/* Avanti Food — Karussell-Pfeile nur am Computer (Maus/Trackpad).
 *
 * Am Computer zeigt jedes Produkt-Karussell eine feste Anzahl ganzer Karten
 * (ab 1100 px Breite 4, darunter 3). Rechts hinter der letzten sichtbaren
 * Karte sitzt ein Pfeil, der die nächsten Karten seitenweise einblendet; links
 * vor der ersten Karte ein Pfeil zurück, sobald man nicht mehr am Anfang ist.
 * Am Ende verschwindet der rechte Pfeil. Auf Touch-Geräten (Handy, Tablet)
 * gibt es keine Pfeile — dort wird gewischt.
 *
 * Wird als type="module" eingebunden: der Browser führt die Datei nur einmal
 * aus, auch wenn mehrere Karussells auf der Seite sind.
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(hover: hover) and (pointer: fine)');
  var SIZE = 40; /* Durchmesser des Pfeil-Buttons in px */
  var ABSTAND = 14; /* Mindestabstand des Pfeils zur Karte und zum Bildschirmrand */
  var PFEIL =
    '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" ' +
    'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10h12M11 5l5 5-5 5"/></svg>';

  function knopf(richtung) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'af-pfeil af-pfeil--' + richtung;
    b.setAttribute('aria-label', richtung === 'vor' ? 'Nächste Produkte' : 'Vorherige Produkte');
    b.innerHTML = PFEIL;
    b.hidden = true;
    return b;
  }

  function einrichten(karussell) {
    if (karussell.__afPfeile) return;
    var scroller = karussell.querySelector(':scope > slideshow-container > slideshow-slides');
    if (!scroller) return;
    karussell.__afPfeile = true;

    var zurueck = knopf('zurueck');
    var vor = knopf('vor');
    karussell.appendChild(zurueck);
    karussell.appendChild(vor);

    /* Nur sichtbare Karten — auf der Produktseite wird das aktuelle Produkt ausgeblendet */
    function karten() {
      return Array.prototype.filter.call(scroller.children, function (el) {
        return el.tagName === 'SLIDESHOW-SLIDE' && el.offsetParent !== null;
      });
    }

    function rahmen() {
      var cs = getComputedStyle(scroller);
      var r = scroller.getBoundingClientRect();
      return {
        links: r.left + (parseFloat(cs.paddingLeft) || 0),
        rechts: r.right - (parseFloat(cs.paddingRight) || 0)
      };
    }

    function ersteSichtbare(liste, f) {
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].getBoundingClientRect().left >= f.links - 2) return i;
      }
      return liste.length - 1;
    }

    function anzahlSichtbar(liste, f) {
      var n = 0;
      liste.forEach(function (k) {
        var r = k.getBoundingClientRect();
        if (r.left >= f.links - 2 && r.right <= f.rechts + 2) n++;
      });
      return Math.max(1, n);
    }

    function blaettern(richtung) {
      var liste = karten();
      if (!liste.length) return;
      var f = rahmen();
      var start = ersteSichtbare(liste, f);
      var n = anzahlSichtbar(liste, f);
      var ziel = richtung > 0 ? Math.min(start + n, liste.length - n) : Math.max(start - n, 0);
      ziel = Math.max(0, ziel);
      var abstand = liste[ziel].getBoundingClientRect().left - f.links;
      scroller.scrollTo({ left: scroller.scrollLeft + abstand, behavior: 'smooth' });
    }

    zurueck.addEventListener('click', function () { blaettern(-1); });
    vor.addEventListener('click', function () { blaettern(1); });

    /* Seitenrand: breit genug, dass der Pfeil mit Abstand zur Karte und zum
       Bildschirmrand hineinpasst. Am Computer wird nichts im Rand angeschnitten -
       es sind nur ganze Karten zu sehen. Nur bei Größenänderung neu berechnen. */
    function rand() {
      if (!DESKTOP.matches) {
        scroller.style.paddingInline = '';
        scroller.style.scrollPaddingInline = '';
        scroller.style.clipPath = '';
        karussell.style.removeProperty('--af-rand');
        return;
      }
      scroller.style.paddingInline = '';
      var basis = parseFloat(getComputedStyle(scroller).paddingRight) || 0;
      var k = karussell.getBoundingClientRect();
      var seite = document.documentElement.clientWidth;
      var aussen = Math.max(0, Math.min(k.left, seite - k.right));
      var noetig = ABSTAND + SIZE + ABSTAND;
      var r = Math.round(Math.max(basis, noetig - aussen));
      karussell.style.setProperty('--af-rand', r + 'px');
      scroller.style.paddingInline = r + 'px';
      scroller.style.scrollPaddingInline = r + 'px';
      scroller.style.clipPath = 'inset(-24px ' + r + 'px -24px ' + r + 'px)';
    }

    var geplant = false;
    function aktualisieren() {
      geplant = false;
      var liste = karten();
      var aktiv = DESKTOP.matches && liste.length > 0 && scroller.scrollWidth > scroller.clientWidth + 4;
      if (!aktiv) {
        zurueck.hidden = true;
        vor.hidden = true;
        return;
      }
      var amAnfang = scroller.scrollLeft <= 4;
      var amEnde = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
      zurueck.hidden = amAnfang;
      vor.hidden = amEnde;

      /* Position: mit festem Abstand neben der letzten bzw. ersten sichtbaren Karte */
      var f = rahmen();
      var k = karussell.getBoundingClientRect();

      /* Höhe: Mitte des Produktbilds der ersten sichtbaren Karte */
      var erste = liste[ersteSichtbare(liste, f)];
      var bild = erste.querySelector('img, .card-gallery, .product-card__media') || erste;
      var b = bild.getBoundingClientRect();
      var mitteY = b.top + b.height / 2 - k.top;

      vor.style.left = (f.rechts + ABSTAND - k.left) + 'px';
      zurueck.style.left = (f.links - ABSTAND - SIZE - k.left) + 'px';
      vor.style.top = zurueck.style.top = (mitteY - SIZE / 2) + 'px';
    }
    function anstossen() {
      if (geplant) return;
      geplant = true;
      setTimeout(aktualisieren, 50);
    }

    function neuAufbauen() {
      rand();
      anstossen();
    }

    scroller.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', neuAufbauen);
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', neuAufbauen);
    if (window.ResizeObserver) new ResizeObserver(neuAufbauen).observe(karussell);
    /* Bilder laden nach — danach Höhe neu berechnen */
    window.addEventListener('load', anstossen);
    neuAufbauen();
  }

  function alle() {
    document.querySelectorAll('slideshow-component.resource-list__carousel').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }
  /* Theme-Editor rendert Sections neu */
  document.addEventListener('shopify:section:load', alle);

  /* Karussells, die erst nachgeladen werden (z. B. Produktempfehlungen auf der
     Produktseite), ebenfalls einrichten */
  if (window.MutationObserver) {
    var spaeter = false;
    new MutationObserver(function () {
      if (spaeter) return;
      spaeter = true;
      setTimeout(function () { spaeter = false; alle(); }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
